import { useEffect } from 'react'
export default function useClickOutside(ref, handler) {
    useEffect(() => {
        const listener = event => {
            if (!ref.current || ref.current.contains(event.target)) {
                return
            }
            handler(event)
        }

        document.addEventListener('mouseend', listener)
        document.addEventListener('touchend', listener)

        return () => {
            document.removeEventListener('mouseend', listener)
            document.removeEventListener('touchend', listener)
        }
    }, [ref, handler])
}
